import { ColorPickerModule } from "ngx-color-picker";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { Ng2SearchPipeModule } from "ng2-search-filter";
import { TabsModule } from "ngx-bootstrap/tabs";

import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ModalModule } from "ngx-bootstrap/modal";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { DropzoneModule } from "ngx-dropzone-wrapper";
import { DropzoneConfigInterface } from "ngx-dropzone-wrapper";
import { NgSelectModule } from "@ng-select/ng-select";
import { UiSwitchModule } from "ngx-ui-switch";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";
import { CarouselModule } from "ngx-bootstrap/carousel";
import { NgApexchartsModule } from "ng-apexcharts";
import { SimplebarAngularModule } from "simplebar-angular";

import { QRCodeModule } from "angularx-qrcode";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { TranslateModule } from "@ngx-translate/core";
import { BrandBarComponent } from "./brand-bar/brand-bar.component";
import { NavBarComponent } from "./navbar/navbar.component";
import { NavDrawerBarComponent } from "./navdrawerbar/navdrawerbar.component";
import { CommonTabComponent } from "./common-tab-component/common-tab-component.component";
import { FeedsComponent } from "./feeds/feeds.component";
import { WebViewComponent } from "./web-view/web-view.component";
import { VideoViewComponent } from "./video-view/video-view.component";
import { SearchViewComponent } from "./search-view/search-view.component";
import { MenusComponent } from "./menus/menus.component";
import { QrViewComponent } from "./qr-view/qr-view.component";
import { QrPageViewComponent } from "./qr-page-view/qr-page-view.component";
import { ButtonSeparatorComponent } from "./button-separators/button-separator.component";
import { ButtonSubmitComponent } from "./button-submit/button-submit.component";
import { ButtonInputComponent } from "./button-input/button-input.component";
import { ButtonSingleChoiceComponent } from "./button-single-choice/button-single-choice.component";
import { ButtonMultiChoiceComponent } from "./button-multi-choice/button-multi-choice.component";
import { OffcanvasTabDragComponent } from "./offcanvas-tab-drag/offcanvas-tab-drag.component";
import { OffcanvasButtonDragComponent } from "./offcanvas-button-drag/offcanvas-button-drag.component";
import {DragDropModule} from '@angular/cdk/drag-drop';
import { OffcanvasTabSettingsComponent } from "./offcanvas-tab-settings/offcanvas-tab-settings.component";
import { OffcanvasSettingsComponentModule } from "../offcanvas-settings-component/offcanvas-settings-component.module";
import { MapSearchViewComponent } from "./map-search-view/map-search-view.component";
import { OffcanvasButtonSettingsComponent } from "./offcanvas-button-settings/offcanvas-button-settings.component";
import { ButtonPageTextComponent } from "./button-pagetext/button-pagetext.component";
import { ButtonPageSliderComponent } from "./button-pageslider/button-pageslider.component";
import { ChatViewComponent } from "./chat-view-component/chat-view-component.component";
import { ButtonPageTextViewComponent } from "./button-pagetext-view/button-pagetext-view.component";
import { ButtonPageGalleryComponent } from "./button-pagegallery/button-pagegallery.component";
import { ButtonPageSingleImageComponent } from "./button-pagesingleimage/button-pagesingleimage.component";
import { ButtonPageHeaderComponent } from "./button-pageheader/button-pageheader.component";
import { ButtonPageDividerComponent } from "./button-pagedivider/button-pagedivider.component";
import { ButtonPageVideoComponent } from "./button-pagevideo/button-pagevideo.component";
import { ButtonPageQrCodeComponent } from "./button-pageqrcode/button-pageqrcode.component";
import { ButtonPageLocationComponent } from "./button-pagelocation/button-pagelocation.component";
import { GoogleMapsModule } from "@angular/google-maps";
import { ButtonPagePdfViewerComponent } from "./button-pagepdfviewer/button-pagepdfviewer.component";
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ButtonPageSocialBarComponent } from "./button-pagesocialbar/button-pagesocialbar.component";
import { ProgressParComponent } from "./progress-par/progress-par.component";
import { ButtonPageSliderLabelComponent } from "./button-pagesliderlabel/button-pagesliderlabel.component";
import { ButtonOutputComponent } from "./button-output/button-output.component";
import { ButtonDropdownComponent } from "./button-dropdown/button-dropdown.component";
import { ButtonSplashComponent } from "./button-splash/button-splash.component";
import { OffcanvasGenSettingsComponent } from "./offcanvas-gen-settings/offcanvas-gen-settings.component";
import { ButtonToggleComponent } from "./button-toggle/button-toggle.component";
import { ButtonCardComponent } from "./button-card/button-card.component";
import { ButtonCollectionComponent } from "./button-collection/button-collection.component";
import { PaletteComponent } from "./palette/palette.component";
import { MenuSliderComponent } from "./menu-slider/menu-slider.component";
import { MobileViewComponent } from "./mobile-view/mobile-view.component";
import { MobileViewButtonComponent } from "./mobile-view-button/mobile-view-button.component";
import { MobileViewSliderComponent } from "./mobile-view-slider/mobile-view-slider.component";
import { MobileViewTabComponent } from "./mobile-view-tab/mobile-view-tab.component";
import { OnClicksSelectorComponent } from "./onClick-selector/onClick-selector.component";
import { SharedModule } from "../shared/shared.module";
import { ScreenSelectorComponent } from "./screen-selector/screen-selector.component";
import { SelectorsModule } from "../selector/selectors.module";
import { PollsSelectorComponent } from "./polls-selector/polls-selector.component";
import { IDrawerComponent } from "./idrawer/idrawer.component";
import { OffcanvasValidationListComponent } from "./offcanvas-validation-list/offcanvas-validation-list.component";
import { ButtonMultiSegmentedComponent } from "./button-multi-segmented/button-multi-segmented.component";
import { ButtonSingleChoiceSegmentedComponent } from "./button-single-choice-segmented/button-single-choice-segmented.component";
import { WireframeComponent } from "../pages/app-builder/wireframe/wireframe.component";
import { FFlowModule } from "@foblex/flow";
import { ButtonMultiChipsetComponent } from "./button-multi-chipset/button-multi-chipset.component";
import {MatChipsModule} from '@angular/material/chips';
import { ButtonSingleChipsetComponent } from "./button-single-chipset/button-single-chipset.component";
import { ButtonAssistChipsetComponent } from "./button-assist-chipset/button-assist-chipset.component";
import { ButtonDropdownChipComponent } from "./button-dropdown-chip/button-dropdown-chip.component";
import { ButtonSearchInputComponent } from "./button-search-input/button-search-input.component";
import { TourNgxBootstrapModule } from "ngx-ui-tour-ngx-bootstrap";
import { ButtonCarouselComponent } from "./button-carousel/button-carousel.component";
import { ButtonSliderComponent } from "./button-slider/button-slider.component";
import { ButtonDatepickerComponent } from "./button-datepicker/button-datepicker.component";
import { ButtonDateRangePickerComponent } from "./button-dateRangePicker/button-dateRangePicker.component";
import { ButtonTimepickerComponent } from "./button-timepicker/button-timepicker.component";
import { TabButtonStyleSearchComponent } from "./tabbuttonstylesearch/tabbuttonstylesearch.component";
import { ButtonFillerComponent } from "./button-filler/button-filler.component";
import { ButtonWebMediaComponent } from "./button-web-media-component/button-web-media-component.component";
import { ButtonWebLocationComponent } from "./button-web-location-component/button-web-location-component.component";
import { ButtonWebInputComponent } from "./button-web-input-component/button-web-input-component.component";
import { ButtonWebDropdownComponent } from "./button-web-dropdown-component/button-web-dropdown-component.component";
import { ButtonWebSingleChoiceComponent } from "./button-web-single-choice-component/button-web-single-choice-component.component";
import { ButtonWebMultiChoiceComponent } from "./button-web-multi-choice-component/button-web-multi-choice-component.component";
import { ButtonWebToggleComponent } from "./button-web-toggle-component/button-web-toggle-component.component";
import { ButtonTextAreaComponent } from "./button-text-area/button-text-area.component";
import { ButtonImagePickerComponent } from "./button-image-picker/button-image-picker.component";
import { ButtonWebDatepickerComponent } from "./button-web-datepicker/button-web-datepicker.component";
import { ButtonWebDateRangepickerComponent } from "./button-web-dateRangepicker/button-web-dateRangepicker.component";
import { ButtonWebTimepickerComponent } from "./button-web-timepicker/button-web-timepicker.component";
import { MatTimepickerModule, provideNativeDateTimeAdapter } from "@dhutaryan/ngx-mat-timepicker";
import { ButtonWebSingleSliderComponent } from "./button-web-single-slider/button-web-single-slider.component";
import { ButtonIconComponent } from "./button-icon/button-icon.component";
import { ButtonContextMenuComponent } from "./button-context-menu/button-context-menu.component";
import { TabSetAppBarComponent } from "./tab-set-appbar-component/tab-set-appbar-component.component";
import { CustomAppbarComponent } from "./custom-appbar/custom-appbar.component";
import { GenAppbarComponentComponent } from "./gen-appbar-component/gen-appbar-component.component";
import { ButtonVideoPickerComponent } from "./button-video-picker/button-video-picker.component";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { ButtonLocationPickerComponent } from "./button-location-picker/button-location-picker.component";
import { ButtonMapComponent } from "./button-map/button-map.component";
import { PlanCheckComponent } from "./plan-modal/plan-modal.component";
import { ButtonShippingPickerComponent } from "./button-shipping-picker/button-shipping-picker.component";
import { ButtonDeliveryPickerComponent } from "./button-delivery_picker/button-delivery_picker.component";
import { ButtonFilePickerComponent } from "./button-file-picker/button-file-picker.component";
import { ButtonVoiceRecorderComponent } from "./button-voice_recorder/button-voice-recorder.component";
import { ButtonAudioPickerComponent } from "./button-audio-picker/button-audio-picker.component";
import { ButtonListItemComponent } from "./button-list-item/button-list-item.component";
import { ButtonContactPickerComponent } from "./button-contact-picker/button-contact-picker.component";
import { ButtonWebFileComponent } from "./button-web-file-component/button-web-file-component.component";
import { ButtonWebRangeSliderComponent } from "./button-web-range-slider/button-web-range-slider.component";
import { ButtonHorizontalListComponent } from "./button-horizontal-list/button-horizontal-list.component";



const config: DropzoneConfigInterface = {
  // Change this to your upload POST address:
  url: "https://httpbin.org/post",
  maxFilesize: 100,
};


@NgModule({
  // tslint:disable-next-line: max-line-length
  declarations: [
    BrandBarComponent,
    NavBarComponent,
    NavDrawerBarComponent,
    CommonTabComponent,
    FeedsComponent,
    IDrawerComponent,
    WebViewComponent,
    VideoViewComponent,
    SearchViewComponent,
    MenusComponent,
    QrViewComponent,
    QrPageViewComponent,
    ChatViewComponent,
    ButtonSeparatorComponent,
    ButtonSubmitComponent,
    ButtonInputComponent,
    ButtonLocationPickerComponent,
    ButtonSingleChoiceComponent,
    ButtonMultiChoiceComponent,
    OffcanvasTabDragComponent,
    OffcanvasButtonDragComponent,
    OffcanvasTabSettingsComponent,
    MapSearchViewComponent,
    OffcanvasButtonSettingsComponent,
    OffcanvasValidationListComponent,
    ButtonPageSliderComponent,
    ButtonPageTextComponent,
    ButtonPageTextViewComponent,
    ButtonPageGalleryComponent,
    ButtonPageSingleImageComponent,
    ButtonPageHeaderComponent,
    ButtonPageDividerComponent,
    ButtonPageVideoComponent,
    ButtonPageQrCodeComponent,
    ButtonPageLocationComponent,
    ButtonPagePdfViewerComponent,
    ButtonPageSocialBarComponent,
    ProgressParComponent,
    ButtonPageSliderLabelComponent,
    ButtonCardComponent,
    ButtonMapComponent,
    ButtonFillerComponent,
    ButtonCollectionComponent,
    ButtonOutputComponent,
    ButtonDropdownComponent,
    ButtonSplashComponent,
    OffcanvasGenSettingsComponent,
    ButtonToggleComponent,
    PaletteComponent,
    MenuSliderComponent,
    MobileViewComponent,
    MobileViewButtonComponent,
    MobileViewSliderComponent,
    MobileViewTabComponent,
    OnClicksSelectorComponent,
    ScreenSelectorComponent,
    PollsSelectorComponent,
    ButtonMultiSegmentedComponent,
    ButtonSingleChoiceSegmentedComponent,
    WireframeComponent,
    ButtonMultiChipsetComponent,
    ButtonSingleChipsetComponent,
    ButtonAssistChipsetComponent,
    ButtonDropdownChipComponent,
    ButtonSearchInputComponent,
    ButtonCarouselComponent,
    ButtonSliderComponent,
    ButtonDatepickerComponent,
    ButtonDateRangePickerComponent,
    ButtonTimepickerComponent,
    TabButtonStyleSearchComponent,
    ButtonWebMediaComponent,
    ButtonWebLocationComponent,
    ButtonWebInputComponent,
    ButtonWebDropdownComponent,
    ButtonWebSingleChoiceComponent,
    ButtonWebMultiChoiceComponent,
    ButtonWebToggleComponent,
    ButtonTextAreaComponent,
    ButtonImagePickerComponent,
    ButtonWebDatepickerComponent,
    ButtonWebDateRangepickerComponent,
    ButtonWebTimepickerComponent,
    ButtonWebSingleSliderComponent,
    ButtonIconComponent,
    ButtonContextMenuComponent,
    TabSetAppBarComponent,
    CustomAppbarComponent,
    GenAppbarComponentComponent,
    ButtonVideoPickerComponent,
    PlanCheckComponent,
    ButtonShippingPickerComponent,
    ButtonDeliveryPickerComponent,
    ButtonFilePickerComponent,
    ButtonVoiceRecorderComponent,
    ButtonAudioPickerComponent,
    ButtonListItemComponent,
    ButtonContactPickerComponent,
    ButtonWebFileComponent,
    ButtonWebRangeSliderComponent,
    ButtonHorizontalListComponent
  ],
  imports: [
    CommonModule,
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    FormsModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    DropzoneModule,
    ReactiveFormsModule,
    NgSelectModule,
    PaginationModule.forRoot(),
    UiSwitchModule,
    CKEditorModule,
    CarouselModule.forRoot(),
    NgApexchartsModule,
    SimplebarAngularModule,
    TranslateModule,
    QRCodeModule,
    AccordionModule.forRoot(),
    BsDatepickerModule.forRoot(),
    DragDropModule,
    OffcanvasSettingsComponentModule,
    GoogleMapsModule,
    PdfViewerModule,
    SelectorsModule,
    FFlowModule,
    TourNgxBootstrapModule,
    MatTimepickerModule
  ],
  exports: [
    BrandBarComponent,
    NavBarComponent,
    NavDrawerBarComponent,
    CommonTabComponent,
    FeedsComponent,
    IDrawerComponent,
    WebViewComponent,
    VideoViewComponent,
    SearchViewComponent,
    SearchViewComponent,
    MenusComponent,
    ChatViewComponent,
    QrViewComponent,
    QrPageViewComponent,
    OffcanvasTabDragComponent,
    OffcanvasButtonDragComponent,
    OffcanvasTabSettingsComponent,
    OffcanvasGenSettingsComponent,
    MapSearchViewComponent,
    OffcanvasButtonSettingsComponent,
    OffcanvasValidationListComponent,
    ButtonPageTextComponent,
    ButtonPageSliderComponent,
    ButtonPageTextViewComponent,
    ButtonPageGalleryComponent,
    ButtonPageSingleImageComponent,
    ButtonPageHeaderComponent,
    ButtonPageDividerComponent,
    ButtonPageVideoComponent,
    ButtonPageQrCodeComponent,
    ButtonPageLocationComponent,
    ButtonPagePdfViewerComponent,
    ButtonPageSocialBarComponent,
    ProgressParComponent,
    ButtonPageSliderLabelComponent,
    ButtonCardComponent,
    ButtonMapComponent,
    ButtonInputComponent,
    ButtonLocationPickerComponent,
    ButtonFillerComponent,
    ButtonCollectionComponent,
    ButtonOutputComponent,
    ButtonDropdownComponent,
    ButtonToggleComponent,
    PaletteComponent,
    MenuSliderComponent,
    MobileViewComponent,
    MobileViewButtonComponent,
    MobileViewSliderComponent,
    MobileViewTabComponent,
    OnClicksSelectorComponent,
    ScreenSelectorComponent,
    PollsSelectorComponent,
    ButtonMultiSegmentedComponent,
    ButtonSingleChoiceSegmentedComponent,
    WireframeComponent,
    ButtonMultiChipsetComponent,
    ButtonSingleChipsetComponent,
    ButtonAssistChipsetComponent,
    ButtonDropdownChipComponent,
    ButtonSearchInputComponent,
    ButtonCarouselComponent,
    ButtonSliderComponent,
    ButtonDatepickerComponent,
    ButtonDateRangePickerComponent,
    ButtonTimepickerComponent,
    TabButtonStyleSearchComponent,
    ButtonWebMediaComponent,
    ButtonWebLocationComponent,
    ButtonWebInputComponent,
    ButtonWebDropdownComponent,
    ButtonWebSingleChoiceComponent,
    ButtonWebMultiChoiceComponent,
    ButtonWebToggleComponent,
    ButtonTextAreaComponent,
    ButtonImagePickerComponent,
    ButtonWebDatepickerComponent,
    ButtonWebDateRangepickerComponent,
    ButtonWebTimepickerComponent,
    ButtonWebSingleSliderComponent,
    ButtonIconComponent,
    ButtonContextMenuComponent,
    TabSetAppBarComponent,
    CustomAppbarComponent,
    GenAppbarComponentComponent,
    ButtonVideoPickerComponent,
    PlanCheckComponent,
    ButtonShippingPickerComponent,
    ButtonDeliveryPickerComponent,
    ButtonFilePickerComponent,
    ButtonVoiceRecorderComponent,
    ButtonAudioPickerComponent,
    ButtonListItemComponent,
    ButtonContactPickerComponent,
    ButtonWebFileComponent,
    ButtonWebRangeSliderComponent,
    ButtonHorizontalListComponent
  ],
  providers: [DatePipe, provideNativeDateTimeAdapter()],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BuilderComponentModule {}
